class SMCardHelper {
  
  constructor() {
    this.stripeKey = SpaceMarket.Config.StripeKey;
  }
  
  removeCardItemBeforeSubmit() {
    // 伝送させたくない情報をフォームから削除する
    $(".js-card-item__remove").each(function(){
      $(this).removeAttr("name");
    });
  }
    
  generateToken(callback) {
    Stripe.setPublishableKey(this.stripeKey);
    Stripe.setLanguage("ja"); 
    const number = $('#js-card_no_1').val() + $('#js-card_no_2').val() + $('#js-card_no_3').val() + $('#js-card_no_4').val();
    Stripe.card.createToken({
     number: number,
     name: $('#js-card_name').val(),
     cvc: $('#js-card_cvc').val(),
     exp_month: $('#js-card_exp_m').val(),
     exp_year: $('#js-card_exp_y').val()
    },
    function(status, response){
      if (response.error) {
        if (callback && callback.error) callback.error(response);
      } else {
        if (callback && callback.success) callback.success(response);
      }  
    });
  }
};
export default SMCardHelper;



// WEBPACK FOOTER //
// ./app/javascript/components/helpers/SMCardHelper.js